export class MockDatadogHelper {
    setDataDogUser = jasmine.createSpy('setDataDogUser');
  }
  